import { render, staticRenderFns } from "./addHomeSupport_.vue?vue&type=template&id=228ebc0e&scoped=true"
import script from "./addHomeSupport_.vue?vue&type=script&lang=js"
export * from "./addHomeSupport_.vue?vue&type=script&lang=js"
import style0 from "./addHomeSupport_.vue?vue&type=style&index=0&id=228ebc0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228ebc0e",
  null
  
)

export default component.exports